import { defineMessages } from 'react-intl'

export const buttonMessages = defineMessages({
  save: {
    id: 'components.ui.button.save',
    defaultMessage: 'Save'
  }
})

export const followButton = defineMessages({
  follow: {
    id: 'components.ui.button.followButton.follow',
    defaultMessage: 'Follow'
  },
  following: {
    id: 'components.ui.button.followButton.following',
    defaultMessage: 'Following'
  },
  unfollow: {
    id: 'components.ui.button.followButton.unfollow',
    defaultMessage: 'Unfollow'
  }
})
